import {Component, OnInit} from '@angular/core';
import {DipRegistrationContextService} from '../core/services/dip-registration-context.service';
import {getApiUrl} from '../core/services/utilities/dip-registration-utility';

@Component({
    selector: 'dip-registration-header',
    templateUrl: 'dip-registration-header.component.html',
    styleUrls: ['./dip-registration-header.component.scss'],
    standalone: false
})
export class DipRegistrationHeaderComponent implements OnInit {
  logoAlt;
  logoSrc;

  constructor(private readonly dipRegistrationContextService: DipRegistrationContextService) {
  }

  ngOnInit(): void {
    const basePath = `${getApiUrl()}/assets/images`;
    const lang = this.dipRegistrationContextService.getLanguage();
    this.logoAlt = lang === 'fr' ? 'TD Assurance' : 'TD Insurance';
    this.logoSrc = lang === 'fr' ? `${basePath}/TD-Insurance_FR.svg` : `${basePath}/TD-Insurance_EN.svg`;
  }
}

